var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg001LogoMuvi(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 81.81 90.96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1111{fill:#333;}.cls-1112{fill:#7a87c2;}.cls-1113{fill:#191a34;}.cls-1114{fill:#233982;}.cls-1115{fill:#e6ab31;}.cls-1116{fill:#fdfdfb;}.cls-1117{fill:#c62217;}.cls-1118{fill:#f6e732;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo-cyti"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1111",
    d: "M5.86,80.13,4.59,84.28l-.42,1.6H4.09l-.43-1.6L2.4,80.13H.31V90.76H1.94V86.47c0-1.12-.16-3.32-.28-4.36h0l.69,2.48,1.16,3.35H4.58l1.17-3.35.71-2.48h0c-.09,1-.27,3.24-.27,4.36v4.29H7.86V80.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1111",
    d: "M15.78,80.13v6.72c0,1.72-.73,2.47-1.87,2.47s-1.84-.75-1.84-2.47V80.13H10.16v6.58c0,2.9,1.41,4.25,3.75,4.25s3.69-1.35,3.69-4.25V80.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1111",
    d: "M26.12,80.13l-1.47,5.35c-.32,1.19-.58,2.24-.93,3.45h-.06c-.36-1.21-.6-2.26-.94-3.45l-1.49-5.35h-2l3.3,10.63h2.26l3.29-10.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1111",
    d: "M36.9,81.73v-1.6h-7v1.6h2.56v7.45H29.9v1.58h7V89.18H34.33V81.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1111",
    d: "M46.36,88.27a2.84,2.84,0,0,1-2.16,1c-1.8,0-3-1.48-3-3.89s1.21-3.84,3-3.84a2.7,2.7,0,0,1,2,.85l1.06-1.17a4.25,4.25,0,0,0-3-1.32c-2.82,0-4.93,2-4.93,5.53S41.48,91,44.11,91a4.26,4.26,0,0,0,3.39-1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1111",
    d: "M55.38,80.13,54.08,83c-.36.84-.74,1.62-1.12,2.47H52.9c-.39-.85-.73-1.63-1.1-2.47l-1.32-2.84h-2L52,87.07v3.69h1.9V87.07l3.49-6.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1111",
    d: "M58.36,80.13v1.6h3.35v9H63.6v-9H67v-1.6Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1112",
    x: 70.65,
    y: 79.94,
    width: 10.83,
    height: 10.83
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1113",
    points: "8.81 0 8.81 33.98 0.96 33.98 0.96 0"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1113",
    points: "23.98 0 23.98 33.98 16.13 33.98 16.13 0"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1113",
    points: "38.46 0 38.46 33.98 30.61 33.98 30.61 0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1114",
    d: "M29.51,39.21H9.84L0,56.21l9.84,17H29.51l9.84-17ZM26.23,67.6H13.13L6.57,56.25l6.56-11.36h13.1l6.56,11.36Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1115",
    x: 44.69,
    y: 39.21,
    width: 37.1,
    height: 34.07
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1116",
    d: "M70.41,45l-6.9,11h-.13L56.51,45H53.34V67.49H57.2V52.76h.11l4.5,7.88h3.12l4.54-8.34h.12V67.5h3.86V45Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1117",
    points: "51.6 4.74 62.02 10.97 51.6 16.65 51.6 4.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1117",
    d: "M62.32,11.15,61.8,22.66,60.68,22l-.93-.52L51.63,17h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1117",
    d: "M51.06,4.74,44.35,9.48h6.71V4.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1117",
    d: "M81.81.57,75.06,17l6.73,17s-11.23-6.39-20-11.33l-1.12-.62-.93-.52C55.35,19.05,52,17.15,51.62,17h0l10.72-5.84L81.81.57"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg001LogoMuvi);
export default __webpack_public_path__ + "static/media/001LogoMuvi.77725996eeae33d1d47c506ceeeb9889.svg";
export { ForwardRef as ReactComponent };